export default __webpack_public_path__ + "media/images/wing_-2fa2e01a1183bcd9a903ac1d9e13885e.png";